import GuidelineAnnotationsBarChart from 'components/GuidelineAnnotation/BarChart';
import Loading from 'components/Loading';
import KyError from 'components/errors/KyError';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';

export default function GuidelineSection() {
  const appContext = useAppContext();

  const {response, error} = useGet('site/guidelinesByDrugs', {
    cacheResponse: !appContext.isPreview,
  });

  let barChart = (
    <div className="gaFigure gaFigure--loading figure">
      <Loading />
    </div>
  );

  if (error) {
    barChart = <KyError kyError={error} />;
  } else if (response) {
    barChart = <GuidelineAnnotationsBarChart guidelineSources={response?.data} />;
  }

  return (
    <div id="section-ga">
      <h3>Clinical Guideline Annotations</h3>
      {barChart}
    </div>
  );
}
